import {Injectable} from "@angular/core";
import {DataService} from "../../shared/data.service";
import {ApiEndpoints} from "../../shared/ApiEndpoints";

@Injectable()
export class ImpulseService extends DataService {
  fetchCounters(deviceID, params) {
    return this.postRequest(`${ApiEndpoints.counters}/${deviceID}`, params);
  }
  saveCounter(deviceID, counter) {
    return this.postRequest(`${ApiEndpoints.counter}/${deviceID}`, counter);
  }
  removeCounter(deviceID, counter) {
    return this.postRequest(`${ApiEndpoints.counter}delete/${deviceID}`, counter);
  }
  saveResetCounter(deviceID, counter) {
    return this.postRequest(`${ApiEndpoints.counter}reset/${deviceID}`, counter);
  }
}
